// Section.jsx

import React from 'react';

// Device Detection
import { useIsMobile } from 'hooks/useDeviceDetect';

// CSS
import './Section.css';

/**
 * Section
 * 
 * A simple wrapper component that provides consistent padding and spacing for its children.
 * It adjusts its layout based on the device type (mobile or desktop) to ensure a responsive design.
 * 
 * @param {string} gap - The gap between child elements (default is '12px').
 * @param {ReactNode} children - The content to be rendered inside the section.
 * 
 * @returns {ReactNode} The rendered component.
 */
const Section = ({ gap = '12px', children }) => {

    // ----- DEVICE DETECTION ----- //

    const isMobile = useIsMobile();

    // ----- RENDER ----- //

    return (

        <div className="section-container"
            style={{
                padding: isMobile ? 10 : 20,
                gap: gap,
            }}>
            {children}
        </div>

    );
};

export default Section;
